import space from "assets/stylesheets/modules/spacing.module.scss";

export default space;
